var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5996_1396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8453 0C22.9397 0.0490018 23.9497 1.05898 24 2.15472V21.8221C23.9456 22.9587 22.8703 23.9905 21.731 24H2.33852C1.11892 24.0082 -0.00812285 22.8811 4.4115e-05 21.6615V2.26906C0.0109334 1.12976 1.04133 0.0544465 2.1779 0H21.8453ZM8.73462 3.652H3.91066L10.2278 12.9406L3.86438 20.3221H5.31538L5.3603 20.2051L10.8172 13.8593C10.9152 13.8593 11.2215 14.3426 11.3004 14.4542C12.6629 16.3857 13.9764 18.3593 15.29 20.3221H20.1602L13.5735 10.7001L19.5994 3.652H18.2178L12.927 9.78539L8.73598 3.652H8.73462Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1931 19.2943H15.9458C12.6355 14.4567 9.2326 9.66408 5.87461 4.85102L5.83105 4.68359H8.00891L18.1931 19.2943Z",
    fill: "#707070"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5996_1396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/_twitter.db2b6e01a9951198ce12d40aa26adada.svg";
export { ForwardRef as ReactComponent };